<div class="section-wrapper" id="gcg">
  <div class="container">
    <h3 class="mini-title">GOOD CORPORATE GOVERNANCE</h3>
    
    <h1 class="title" id="company_structure">COMPANY STRUCTURE</h1>
    <div class="img-wrapper company-structure">
      <img src="assets/img/company_structure.png" />
    </div>
  </div>
</div>

<h1 class="title management" id="management">MANAGEMENT & STRUCTURE</h1>
<div class="container">
  <div class="board-wrapper" *ngFor="let board of boards">
    <h2 class="board-title">{{ board.division_name | translate }}</h2>
    <div class="row">
      <div class="col-sm-6 col-md-4" *ngFor="let member of board.members">
        <div class="member-wrapper">
          <div class="img-wrapper member-image" *ngIf="member.profile_picture">
            <img src="assets/img/{{ member.profile_picture }}" />
          </div>
          <p class="member-name">{{ member.name }}</p>
          <p class="member-position">{{ member.position | translate }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
